/* --------------------------------------------------------------- shorthands */
const live = (member, method, path, note) => ({
    member,
    method,
    path,
    state: "live",
    note,
});
const spec = (member, method, path, note) => ({
    member,
    method,
    path,
    state: "contract",
    note,
});
/* ------------------------------------------------------------------- buyers */
const COMMERCE = [
    {
        id: "commerce.home",
        path: "/",
        zh: "首页",
        en: "Home",
        sys: "commerce",
        pri: "P0",
        resp: "首屏承载平台定位、核心品类入口与 AI 选品引导，是买家进入平台的第一触点。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/products")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.categories",
        path: "/categories",
        zh: "类目首页",
        en: "Categories",
        sys: "commerce",
        pri: "P0",
        resp: "按一级类目组织商品发现路径，承接 SEO 与站内导航。",
        owner: "Commerce",
        apis: [spec("commerce", "GET", "/categories"), live("commerce", "GET", "/products")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.category-detail",
        path: "/categories/:slug",
        zh: "类目详情",
        en: "Category",
        sys: "commerce",
        pri: "P0",
        resp: "展示单一类目的商品列表、筛选维度与行业属性模板。",
        owner: "Commerce",
        apis: [spec("commerce", "GET", "/categories/:slug"), live("commerce", "GET", "/products", "category_id 过滤")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.search",
        path: "/search",
        zh: "商品搜索",
        en: "Search",
        sys: "commerce",
        pri: "P0",
        resp: "以关键词、类目、属性组合检索商品与供应能力，并支持跨系统检索。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/products"), live("platform", "GET", "/search")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.product-detail",
        path: "/products/:productId",
        zh: "商品详情",
        en: "Product detail",
        sys: "commerce",
        pri: "P0",
        resp: "呈现商品主数据、SKU、Listing 与报价入口，是 RFQ 与下单的起点。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/products/:productId"), live("commerce", "GET", "/skus/:skuId")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.supplier-profile",
        path: "/suppliers/:slug",
        zh: "工厂 / 供应能力公开页",
        en: "Supplier profile",
        sys: "commerce",
        pri: "P1",
        resp: "公开工厂资质、核心工艺与产能画像，建立买家信任（数据源为制造网络）。",
        owner: "Manufacturing（只读投影至 Commerce）",
        apis: [live("mfg", "GET", "/factories/:factoryId"), spec("commerce", "GET", "/suppliers/:slug")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.ai-sourcing",
        path: "/ai-sourcing",
        zh: "AI 寻品",
        en: "AI sourcing",
        sys: "commerce",
        pri: "P1",
        resp: "由 Agent 依据需求描述检索/组合供应方案，输出可比较的候选清单。",
        owner: "Commerce + R&D（Agent 运行时）",
        apis: [spec("commerce", "POST", "/ai-sourcing/queries"), spec("rnd", "POST", "/agent-runs")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.new-designs",
        path: "/new-designs",
        zh: "AI 新品中心",
        en: "AI new designs",
        sys: "commerce",
        pri: "P1",
        resp: "展示已通过工程审批、可进入预售/定制的 AI 新品。",
        owner: "Commerce（投影自 R&D 发布申请）",
        apis: [spec("commerce", "GET", "/new-designs"), spec("rnd", "POST", "/release-requests")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.new-design-detail",
        path: "/new-designs/:id",
        zh: "AI 新品详情",
        en: "AI new design",
        sys: "commerce",
        pri: "P1",
        resp: "呈现新品设计信息、成本结构与最小起订，承接定制/RFQ。",
        owner: "Commerce（投影自 R&D）",
        apis: [spec("commerce", "GET", "/new-designs/:id"), live("rnd", "GET", "/designs/:designId/versions")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.rfq-new",
        path: "/rfqs/new",
        zh: "RFQ 创建",
        en: "New RFQ",
        sys: "commerce",
        pri: "P0",
        resp: "买家提交询价单（含行项目、目的地、币种与交期），并可立即提交。",
        owner: "Commerce",
        apis: [
            live("commerce", "POST", "/rfqs"),
            live("commerce", "POST", "/rfqs/:id/submit"),
            live("commerce", "GET", "/products"),
        ],
        scope: "commerce:rfq:write",
    },
    {
        id: "commerce.workspace-rfqs",
        path: "/workspace/rfqs",
        zh: "RFQ 列表",
        en: "RFQs",
        sys: "commerce",
        pri: "P0",
        resp: "集中查看本租户全部询价单及其状态、报价数量与交期。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/rfqs"), live("commerce", "POST", "/rfqs")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.workspace-rfq-detail",
        path: "/workspace/rfqs/:rfqId",
        zh: "RFQ 详情",
        en: "RFQ detail",
        sys: "commerce",
        pri: "P0",
        resp: "查看询价单行项目、报价集合与提交状态，并可直接接受报价。",
        owner: "Commerce",
        apis: [
            live("commerce", "GET", "/rfqs/:rfqId"),
            live("commerce", "GET", "/rfqs/:rfqId/quotes"),
            live("commerce", "POST", "/rfqs/:rfqId/quotes"),
            live("commerce", "POST", "/rfqs/:id/submit"),
        ],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.quote-detail",
        path: "/workspace/quotes/:quoteId",
        zh: "报价详情",
        en: "Quote detail",
        sys: "commerce",
        pri: "P0",
        resp: "呈现单一报价的价格、交期与行项目，是接受/拒绝决策的操作页。",
        owner: "Commerce",
        apis: [
            live("commerce", "GET", "/rfqs/:rfqId/quotes", "按 RFQ 聚合返回，含行项目"),
            live("commerce", "POST", "/quotes/:quoteId/accept"),
        ],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.quote-compare",
        path: "/workspace/quotes/compare",
        zh: "报价比较",
        en: "Quote comparison",
        sys: "commerce",
        pri: "P1",
        resp: "横向比较同一 RFQ 的多份报价（价格、交期、行匹配度）并选择接受行。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/rfqs/:rfqId/quotes"), live("commerce", "POST", "/quotes/:quoteId/accept")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.customizations",
        path: "/workspace/customizations",
        zh: "定制项目",
        en: "Customization projects",
        sys: "commerce",
        pri: "P1",
        resp: "管理 OEM/ODM 定制项目从需求到报价的整体进度。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/customization-projects"), live("commerce", "POST", "/customization-projects")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.customization-detail",
        path: "/workspace/customizations/:id",
        zh: "定制项目详情",
        en: "Customization project",
        sys: "commerce",
        pri: "P1",
        resp: "呈现定制需求、打样与工程版本关联，串联 R&D 与制造。",
        owner: "Commerce",
        apis: [spec("commerce", "GET", "/customization-projects/:id"), live("commerce", "GET", "/customization-projects")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.samples",
        path: "/workspace/samples",
        zh: "样品项目",
        en: "Samples",
        sys: "commerce",
        pri: "P1",
        resp: "买家侧跟踪打样进度与样品验收结论（数据源为 R&D 样品单）。",
        owner: "R&D（买家只读视图）",
        apis: [spec("rnd", "GET", "/sample-orders"), live("rnd", "POST", "/sample-orders")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.lists",
        path: "/workspace/lists",
        zh: "采购清单",
        en: "Shopping lists",
        sys: "commerce",
        pri: "P1",
        resp: "按项目/批次组织待采购商品，支持一次性转 RFQ 或购物车。",
        owner: "Commerce",
        apis: [spec("commerce", "GET", "/shopping-lists")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.cart",
        path: "/cart",
        zh: "购物车",
        en: "Cart",
        sys: "commerce",
        pri: "P0",
        resp: "聚合标准品采购行，进入结账会话。",
        owner: "Commerce（Medusa cart）",
        apis: [spec("commerce", "GET", "/cart"), spec("commerce", "POST", "/checkout-sessions")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.checkout",
        path: "/checkout",
        zh: "结账",
        en: "Checkout",
        sys: "commerce",
        pri: "P0",
        resp: "创建结账会话，收集贸易条款与收货信息，交由支付与 SCM 承接。",
        owner: "Commerce → SCM",
        apis: [live("commerce", "POST", "/checkout-sessions"), live("commerce", "POST", "/checkout-sessions/:sessionId/complete")],
        scope: "commerce:rfq:write",
    },
    {
        id: "commerce.checkout-success",
        path: "/checkout/success",
        zh: "下单成功",
        en: "Order placed",
        sys: "commerce",
        pri: "P0",
        resp: "确认订单号、金额与后续履约节点，提供进入订单详情的入口。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/orders/:orderId")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.workspace",
        path: "/workspace",
        zh: "客户 Dashboard",
        en: "Buyer dashboard",
        sys: "commerce",
        pri: "P0",
        resp: "买家工作台总览：进行中的 RFQ、待决策报价、在途订单与待办。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/rfqs"), live("commerce", "GET", "/orders"), live("commerce", "GET", "/products")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.orders",
        path: "/workspace/orders",
        zh: "订单列表",
        en: "Orders",
        sys: "commerce",
        pri: "P0",
        resp: "买家订单总览，展示状态、金额与履约阶段。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/orders")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.order-detail",
        path: "/workspace/orders/:orderId",
        zh: "订单详情",
        en: "Order detail",
        sys: "commerce",
        pri: "P0",
        resp: "订单头、行项目、支付与履约时间线；跨系统聚合需经 SCM 聚合视图。",
        owner: "Commerce / SCM",
        apis: [live("commerce", "GET", "/orders/:orderId"), live("scm", "GET", "/customer-orders/:orderId")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.shipment-detail",
        path: "/workspace/shipments/:shipmentId",
        zh: "货件 / 物流详情",
        en: "Shipment",
        sys: "commerce",
        pri: "P1",
        resp: "买家侧物流跟踪：运单、包裹、轨迹事件与预计到达。",
        owner: "SCM",
        apis: [live("scm", "GET", "/shipments/:shipmentId"), live("scm", "POST", "/shipments/:shipmentId/tracking-events")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.billing",
        path: "/workspace/billing",
        zh: "支付与账单",
        en: "Billing",
        sys: "commerce",
        pri: "P1",
        resp: "账单、支付状态与发票下载；支付事实由 SCM 账本权威。",
        owner: "SCM（买家视图）",
        apis: [spec("scm", "GET", "/billing/invoices"), live("scm", "GET", "/ledger/orders/:orderId")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.documents",
        path: "/workspace/documents",
        zh: "文件中心",
        en: "Documents",
        sys: "commerce",
        pri: "P1",
        resp: "租户文件资产的统一入口：上传、扫描状态、下载授权链接。",
        owner: "platform-core",
        apis: [
            live("platform", "GET", "/files"),
            live("platform", "POST", "/files"),
            live("platform", "GET", "/files/:assetId/download-url"),
            live("platform", "GET", "/files/allowed-types"),
        ],
        scope: "platform:file:read",
    },
    {
        id: "commerce.quality",
        path: "/workspace/quality",
        zh: "质检报告",
        en: "Quality reports",
        sys: "commerce",
        pri: "P1",
        resp: "买家查看订单关联的质检结论与不合格处理结果。",
        owner: "SCM",
        apis: [live("scm", "GET", "/inspections/:inspectionId"), spec("scm", "GET", "/inspections")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.cases",
        path: "/workspace/cases",
        zh: "售后中心",
        en: "After-sales cases",
        sys: "commerce",
        pri: "P1",
        resp: "买家提交与跟踪索赔/售后案件，结果由 SCM 索赔流程裁决。",
        owner: "SCM",
        apis: [live("scm", "GET", "/claims/:claimId"), spec("scm", "GET", "/claims")],
        scope: "commerce:catalog:read",
    },
    {
        id: "commerce.members",
        path: "/workspace/settings/members",
        zh: "企业成员",
        en: "Team members",
        sys: "commerce",
        pri: "P1",
        resp: "管理企业成员及其采购角色与权限边界。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/buyer-members"), live("commerce", "POST", "/buyer-members")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.company",
        path: "/workspace/settings/company",
        zh: "企业资料",
        en: "Company profile",
        sys: "commerce",
        pri: "P0",
        resp: "维护企业主体信息、默认币种与贸易默认条款，影响报价与订单快照。",
        owner: "Commerce（buyer_organizations）",
        apis: [spec("commerce", "GET", "/buyer-organization"), spec("commerce", "PUT", "/buyer-organization")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.addresses",
        path: "/workspace/settings/addresses",
        zh: "地址簿",
        en: "Addresses",
        sys: "commerce",
        pri: "P0",
        resp: "维护收货/账单地址，供结账与贸易单据使用。",
        owner: "Commerce",
        apis: [spec("commerce", "GET", "/addresses"), spec("commerce", "POST", "/addresses")],
        scope: "commerce:rfq:read",
    },
    {
        id: "commerce.approvals",
        path: "/workspace/approvals",
        zh: "采购审批",
        en: "Purchase approvals",
        sys: "commerce",
        pri: "P2",
        resp: "企业内采购审批队列，审批动作走 platform-core 工作流引擎。",
        owner: "platform-core（工作流）",
        apis: [live("platform", "GET", "/workflow-tasks"), live("platform", "POST", "/workflow-tasks/:taskId/decision")],
        scope: "platform:workflow:read",
    },
];
/* ---------------------------------------------------------------------- R&D */
const RND = [
    {
        id: "rnd.dashboard",
        path: "/rd",
        zh: "研发 Dashboard",
        en: "R&D dashboard",
        sys: "rnd",
        pri: "P0",
        resp: "研发工作台总览：在研项目、AI 任务队列、待审批工程版本与 Agent 运行健康度。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/projects"), live("rnd", "GET", "/agent-runs")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.projects",
        path: "/rd/projects",
        zh: "研发项目列表",
        en: "Projects",
        sys: "rnd",
        pri: "P0",
        resp: "研发项目的创建与检索，是所有设计/工程产物的容器。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/projects"), live("rnd", "POST", "/projects")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.project-detail",
        path: "/rd/projects/:projectId",
        zh: "项目详情",
        en: "Project detail",
        sys: "rnd",
        pri: "P0",
        resp: "项目下的设计任务、设计版本与 Agent 运行记录，支持发起新的生成任务。",
        owner: "AI Product R&D",
        apis: [
            live("rnd", "GET", "/projects/:projectId"),
            live("rnd", "POST", "/projects/:projectId/design-jobs"),
            live("rnd", "GET", "/agent-runs"),
        ],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.opportunities",
        path: "/rd/opportunities",
        zh: "产品机会池",
        en: "Opportunity pool",
        sys: "rnd",
        pri: "P1",
        resp: "汇聚市场缺口、买家需求与供应侧信号，形成可评估的产品机会。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/opportunities"), spec("rnd", "POST", "/opportunities")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.intelligence",
        path: "/rd/intelligence",
        zh: "市场趋势",
        en: "Market intelligence",
        sys: "rnd",
        pri: "P1",
        resp: "外部趋势、竞品与价格带的持续采集与归因。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/intelligence/trends")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.briefs",
        path: "/rd/briefs",
        zh: "Product Brief 列表",
        en: "Product briefs",
        sys: "rnd",
        pri: "P0",
        resp: "Brief 是设计任务的输入契约：目标市场、成本带、合规与外观约束。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/briefs"), spec("rnd", "POST", "/briefs")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.brief-detail",
        path: "/rd/briefs/:id",
        zh: "Brief 编辑",
        en: "Brief editor",
        sys: "rnd",
        pri: "P0",
        resp: "编辑 Brief 约束并冻结版本，冻结后不可变更（仅可新建版本）。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/briefs/:id"), spec("rnd", "PUT", "/briefs/:id")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.design-jobs",
        path: "/rd/design-jobs",
        zh: "AI 设计任务",
        en: "Design jobs",
        sys: "rnd",
        pri: "P0",
        resp: "按项目检视设计任务状态机（排队/运行/成功/失败）并触发执行。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/projects"), live("rnd", "GET", "/design-jobs/:jobId"), live("rnd", "POST", "/design-jobs/:jobId/run")],
        scope: "rnd:job:read",
    },
    {
        id: "rnd.design-job-detail",
        path: "/rd/design-jobs/:jobId",
        zh: "设计任务详情",
        en: "Design job",
        sys: "rnd",
        pri: "P0",
        resp: "任务参数、Agent 运行详情、模型用量与产出回写结果。",
        owner: "AI Product R&D",
        apis: [
            live("rnd", "GET", "/design-jobs/:jobId"),
            live("rnd", "POST", "/design-jobs/:jobId/run"),
            live("rnd", "POST", "/design-jobs/:jobId/results"),
        ],
        scope: "rnd:job:read",
    },
    {
        id: "rnd.design-detail",
        path: "/rd/designs/:designId",
        zh: "设计画布 / 资产详情",
        en: "Design asset",
        sys: "rnd",
        pri: "P0",
        resp: "设计资产与其版本序列的容器，承载几何资产与评审记录。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/designs/:designId/versions"), live("rnd", "POST", "/designs/:designId/versions")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.design-versions",
        path: "/rd/designs/:designId/versions",
        zh: "设计版本对比",
        en: "Design versions",
        sys: "rnd",
        pri: "P1",
        resp: "版本序列与差异对比，任何工程变更必须可追溯。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/designs/:designId/versions"), live("rnd", "POST", "/designs/:designId/versions")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.factory-match",
        path: "/rd/designs/:designId/factory-match",
        zh: "制造能力匹配",
        en: "Factory match",
        sys: "rnd",
        pri: "P1",
        resp: "按工程版本匹配具备对应工艺与产能的工厂，输出候选与匹配理由。",
        owner: "AI Product R&D → Manufacturing",
        apis: [
            live("rnd", "POST", "/engineering-revisions/:revisionId/factory-matches"),
            live("rnd", "GET", "/engineering-revisions/:revisionId/factory-matches"),
            live("mfg", "GET", "/factories"),
        ],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.dfm",
        path: "/rd/designs/:designId/dfm",
        zh: "DFM 报告",
        en: "DFM report",
        sys: "rnd",
        pri: "P1",
        resp: "可制造性评估：结论（通过/需整改/失败）、分值、问题与整改建议。",
        owner: "AI Product R&D",
        apis: [
            live("rnd", "POST", "/engineering-revisions/:revisionId/dfm-evaluations"),
            live("rnd", "GET", "/dfm-evaluations/:evaluationId"),
            live("rnd", "POST", "/dfm-evaluations/:evaluationId/result"),
        ],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.costing",
        path: "/rd/designs/:designId/costing",
        zh: "BOM 与成本",
        en: "BOM & costing",
        sys: "rnd",
        pri: "P1",
        resp: "BOM 版本与成本估算，是报价与毛利模型的源头。",
        owner: "AI Product R&D",
        apis: [
            live("rnd", "POST", "/engineering-revisions/:revisionId/bom-versions"),
            live("rnd", "GET", "/engineering-revisions/:revisionId/bom-versions"),
            live("rnd", "POST", "/engineering-revisions/:revisionId/cost-estimates"),
        ],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.samples",
        path: "/rd/samples",
        zh: "样品管理",
        en: "Samples",
        sys: "rnd",
        pri: "P1",
        resp: "打样单创建与样品验证结论，验证通过方可进入工程审批。",
        owner: "AI Product R&D",
        apis: [live("rnd", "POST", "/sample-orders"), live("rnd", "POST", "/sample-orders/:sampleOrderId/validation")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.sample-detail",
        path: "/rd/samples/:id",
        zh: "样品详情",
        en: "Sample detail",
        sys: "rnd",
        pri: "P1",
        resp: "样品单详情与验证记录（尺寸/外观/功能结论）。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/sample-orders/:id"), live("rnd", "POST", "/sample-orders/:sampleOrderId/validation")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.engineering-approvals",
        path: "/rd/engineering-approvals",
        zh: "工程审批",
        en: "Engineering approvals",
        sys: "rnd",
        pri: "P1",
        resp: "工程版本冻结前的审批队列：DFM、BOM、成本必须齐备。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "GET", "/engineering-approvals"), spec("rnd", "POST", "/engineering-approvals/:id/decision")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.publications",
        path: "/rd/publications",
        zh: "商品发布申请",
        en: "Publication requests",
        sys: "rnd",
        pri: "P0",
        resp: "将工程版本申请发布为商品，是 R&D → Commerce 的唯一合法出口。",
        owner: "AI Product R&D → Commerce",
        apis: [live("rnd", "POST", "/release-requests"), live("rnd", "POST", "/release-requests/:releaseId/approve")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.publication-detail",
        path: "/rd/publications/:id",
        zh: "发布审核详情",
        en: "Publication review",
        sys: "rnd",
        pri: "P0",
        resp: "发布申请详情与审批动作；批准后 Commerce 侧创建 Listing 草稿。",
        owner: "AI Product R&D → Commerce",
        apis: [live("rnd", "POST", "/release-requests/:releaseId/approve"), spec("rnd", "GET", "/release-requests/:id")],
        scope: "rnd:design:read",
    },
    {
        id: "rnd.analytics",
        path: "/rd/analytics",
        zh: "产品表现分析",
        en: "Product analytics",
        sys: "rnd",
        pri: "P1",
        resp: "设计 → 发布 → 销售的表现回环，用于迭代 Brief。",
        owner: "AI Product R&D（分析库）",
        apis: [spec("rnd", "GET", "/analytics/design-performance")],
        scope: "rnd:project:read",
    },
    {
        id: "rnd.ai-ops",
        path: "/rd/ai-ops",
        zh: "模型与 Agent 管理",
        en: "Model & agent ops",
        sys: "rnd",
        pri: "P2",
        resp: "Agent 运行时、模型路由与 token/成本用量的运维视图。",
        owner: "AI Product R&D",
        apis: [live("rnd", "GET", "/agent-runs", "含模型用量汇总")],
        scope: "rnd:project:read",
    },
];
/* -------------------------------------------------------------- control tower */
const SCM = [
    {
        id: "scm.control-tower",
        path: "/control-tower",
        zh: "控制塔首页",
        en: "Control tower",
        sys: "scm",
        pri: "P0",
        resp: "供应链全局态势：订单阶段分布、采购在途、资金与质检异常。",
        owner: "Supply Chain",
        apis: [
            live("scm", "GET", "/customer-orders"),
            live("scm", "GET", "/supplier-pos"),
            live("scm", "GET", "/warehouses"),
            live("commerce", "GET", "/orders"),
        ],
        scope: "scm:order:read",
    },
    {
        id: "scm.orders",
        path: "/oms/orders",
        zh: "订单总览",
        en: "Customer orders",
        sys: "scm",
        pri: "P0",
        resp: "所有客户订单（含来自 Commerce 的事件快照订单）的权威列表。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/customer-orders"), live("scm", "POST", "/customer-orders")],
        scope: "scm:order:read",
    },
    {
        id: "scm.order-detail",
        path: "/oms/orders/:orderId",
        zh: "订单详情 / 时间线",
        en: "Order timeline",
        sys: "scm",
        pri: "P0",
        resp: "订单聚合：冻结的贸易快照、行项目、PO、支付、质检、货件与账本。",
        owner: "Supply Chain",
        apis: [
            live("scm", "GET", "/customer-orders/:orderId"),
            live("scm", "GET", "/ledger/orders/:orderId"),
            live("scm", "POST", "/customer-orders/:orderId/procurement-plans"),
            live("scm", "GET", "/customer-orders/:orderId/trade-documents"),
        ],
        scope: "scm:order:read",
    },
    {
        id: "scm.plans",
        path: "/procurement/plans",
        zh: "采购计划",
        en: "Procurement plans",
        sys: "scm",
        pri: "P0",
        resp: "由订单驱动的采购分配（reserved/fulfilled）与缺口分析。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/customer-orders"), live("scm", "POST", "/customer-orders/:orderId/procurement-plans")],
        scope: "scm:order:read",
    },
    {
        id: "scm.plan-detail",
        path: "/procurement/plans/:orderId",
        zh: "采购计划详情",
        en: "Procurement plan",
        sys: "scm",
        pri: "P1",
        resp: "单一订单的采购分配明细与履约进度。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/customer-orders/:orderId")],
        scope: "scm:order:read",
    },
    {
        id: "scm.pos",
        path: "/procurement/pos",
        zh: "供应商 PO",
        en: "Supplier POs",
        sys: "scm",
        pri: "P0",
        resp: "发往工厂的采购订单，状态机由支付与生产事件推进。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/supplier-pos"), live("scm", "POST", "/supplier-pos"), live("scm", "POST", "/supplier-pos/:poId/issue")],
        scope: "scm:po:read",
    },
    {
        id: "scm.po-detail",
        path: "/procurement/pos/:poId",
        zh: "PO 详情",
        en: "PO detail",
        sys: "scm",
        pri: "P0",
        resp: "PO 行项目、工厂确认（acknowledgement）与生产/交付进度。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/supplier-pos"), live("scm", "POST", "/supplier-pos/:poId/issue"), spec("scm", "GET", "/supplier-pos/:poId")],
        scope: "scm:po:read",
    },
    {
        id: "scm.suppliers",
        path: "/suppliers",
        zh: "供应商管理",
        en: "Suppliers",
        sys: "scm",
        pri: "P1",
        resp: "合格供应商名录，与制造网络的工厂主数据对齐（不复制主数据）。",
        owner: "Manufacturing（SCM 引用）",
        apis: [live("mfg", "GET", "/factories"), live("mfg", "GET", "/factories/:factoryId/verification")],
        scope: "scm:po:read",
    },
    {
        id: "scm.payments",
        path: "/finance/payments",
        zh: "支付交易",
        en: "Payments",
        sys: "scm",
        pri: "P0",
        resp: "支付意图的创建、捕获与失败处理；每次状态变更落账本分录。",
        owner: "Supply Chain",
        apis: [
            live("scm", "POST", "/payment-intents"),
            live("scm", "GET", "/payment-intents/:paymentIntentId"),
            live("scm", "POST", "/payment-intents/:paymentIntentId/capture"),
            live("scm", "POST", "/payment-intents/:paymentIntentId/fail"),
        ],
        scope: "scm:payment:read",
    },
    {
        id: "scm.refunds",
        path: "/finance/refunds",
        zh: "退款管理",
        en: "Refunds",
        sys: "scm",
        pri: "P1",
        resp: "退款发起与完成，冲销原分录并保留审计链。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/refunds"), live("scm", "POST", "/refunds/:refundId/complete")],
        scope: "scm:payment:read",
    },
    {
        id: "scm.ledger",
        path: "/finance/ledger",
        zh: "账本与分录",
        en: "Ledger",
        sys: "scm",
        pri: "P0",
        resp: "按订单查看复式记账分录，借贷必须平衡。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/ledger/orders/:orderId")],
        scope: "scm:payment:read",
    },
    {
        id: "scm.reconciliation",
        path: "/finance/reconciliation",
        zh: "对账中心",
        en: "Reconciliation",
        sys: "scm",
        pri: "P0",
        resp: "支付服务商流水与内部账本的差异识别与归集。",
        owner: "Supply Chain",
        apis: [spec("scm", "GET", "/reconciliation/statements"), live("scm", "POST", "/webhooks/payment-providers/:provider")],
        scope: "scm:payment:read",
    },
    {
        id: "scm.profitability",
        path: "/finance/profitability",
        zh: "毛利分析",
        en: "Profitability",
        sys: "scm",
        pri: "P1",
        resp: "订单级收入/成本/毛利拆解，成本来源于 R&D 成本估算与 PO 实付。",
        owner: "Supply Chain（分析库）",
        apis: [spec("scm", "GET", "/analytics/profitability")],
        scope: "scm:payment:read",
    },
    {
        id: "scm.inspections",
        path: "/quality/inspections",
        zh: "质检任务",
        en: "Inspections",
        sys: "scm",
        pri: "P0",
        resp: "按标准与抽样规则创建质检任务并登记结论。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/inspections"), live("scm", "GET", "/inspections/:inspectionId"), live("scm", "POST", "/inspections/:inspectionId/result")],
        scope: "scm:quality:read",
    },
    {
        id: "scm.inspection-detail",
        path: "/quality/inspections/:inspectionId",
        zh: "质检详情",
        en: "Inspection detail",
        sys: "scm",
        pri: "P0",
        resp: "抽样明细、检查项结果与放行/拒收判定。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/inspections/:inspectionId"), live("scm", "POST", "/inspections/:inspectionId/result")],
        scope: "scm:quality:read",
    },
    {
        id: "scm.ncr",
        path: "/quality/ncr",
        zh: "不合格处理",
        en: "Nonconformance",
        sys: "scm",
        pri: "P1",
        resp: "不合格品的处置（返工/让步/报废）与索赔联动。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/inspections/:inspectionId"), live("scm", "POST", "/claims")],
        scope: "scm:quality:read",
    },
    {
        id: "scm.warehouses",
        path: "/warehouse",
        zh: "仓库管理",
        en: "Warehouses",
        sys: "scm",
        pri: "P1",
        resp: "仓库主数据与库存视图，支撑集货与出库。",
        owner: "Supply Chain",
        apis: [live("scm", "GET", "/warehouses"), live("scm", "POST", "/warehouses"), live("scm", "GET", "/warehouses/:warehouseId/inventory")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.receipts",
        path: "/warehouse/receipts",
        zh: "入库任务",
        en: "Receipts",
        sys: "scm",
        pri: "P1",
        resp: "工厂到货入库登记，形成可分配库存。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/warehouses/:warehouseId/receipts"), live("scm", "GET", "/warehouses/:warehouseId/inventory")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.dispatches",
        path: "/warehouse/dispatches",
        zh: "集货 / 出库",
        en: "Dispatches",
        sys: "scm",
        pri: "P1",
        resp: "按货件集货并出库，触发货件派发事件。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/shipments/:shipmentId/packages"), live("scm", "POST", "/shipments/:shipmentId/dispatch")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.shipments",
        path: "/logistics/shipments",
        zh: "货件总览",
        en: "Shipments",
        sys: "scm",
        pri: "P0",
        resp: "全部货件的模式、起运/目的与状态；派发与签收驱动订单履约。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/shipments"), live("scm", "GET", "/shipments/:shipmentId")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.shipment-detail",
        path: "/logistics/shipments/:shipmentId",
        zh: "货件详情",
        en: "Shipment detail",
        sys: "scm",
        pri: "P0",
        resp: "包裹、轨迹事件与签收证明，异常在此归集。",
        owner: "Supply Chain",
        apis: [
            live("scm", "GET", "/shipments/:shipmentId"),
            live("scm", "POST", "/shipments/:shipmentId/tracking-events"),
            live("scm", "POST", "/shipments/:shipmentId/dispatch"),
            live("scm", "POST", "/shipments/:shipmentId/deliver"),
        ],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.logistics-exceptions",
        path: "/logistics/exceptions",
        zh: "物流异常",
        en: "Logistics exceptions",
        sys: "scm",
        pri: "P1",
        resp: "超时、丢件、清关受阻等异常的统一处置队列。",
        owner: "Supply Chain",
        apis: [spec("scm", "GET", "/logistics/exceptions"), live("scm", "POST", "/shipments/:shipmentId/tracking-events")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.trade-documents",
        path: "/trade-documents",
        zh: "贸易文件",
        en: "Trade documents",
        sys: "scm",
        pri: "P1",
        resp: "发票、装箱单、原产地证等文件的生成与状态跟踪。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/trade-documents"), live("scm", "GET", "/customer-orders/:orderId/trade-documents")],
        scope: "scm:logistics:read",
    },
    {
        id: "scm.compliance",
        path: "/compliance/rules",
        zh: "合规规则",
        en: "Compliance rules",
        sys: "scm",
        pri: "P1",
        resp: "目的国准入、认证与关税规则的配置与命中检查。",
        owner: "Supply Chain",
        apis: [spec("scm", "GET", "/compliance/rules"), spec("scm", "POST", "/compliance/checks")],
        scope: "scm:order:read",
    },
    {
        id: "scm.cases",
        path: "/aftersales/cases",
        zh: "售后案件",
        en: "After-sales cases",
        sys: "scm",
        pri: "P1",
        resp: "索赔案件的受理、责任判定与处置结果。",
        owner: "Supply Chain",
        apis: [live("scm", "POST", "/claims"), live("scm", "GET", "/claims/:claimId"), live("scm", "POST", "/claims/:claimId/resolve")],
        scope: "scm:quality:read",
    },
    {
        id: "scm.operations-exceptions",
        path: "/operations/exceptions",
        zh: "异常工作台",
        en: "Exception workbench",
        sys: "scm",
        pri: "P0",
        resp: "跨系统的运行异常：事件死信、Inbox 失败、Outbox 积压，可人工重放。",
        owner: "platform-core（事件运行时）",
        apis: [
            live("commerce", "GET", "/ops/dead-letters"),
            live("commerce", "GET", "/ops/inbox-failures"),
            live("commerce", "POST", "/ops/dead-letters/:eventId/replay"),
            live("commerce", "GET", "/ops/outbox"),
        ],
        scope: "ops:read",
    },
    {
        id: "scm.service-providers",
        path: "/service-providers",
        zh: "服务商管理",
        en: "Service providers",
        sys: "scm",
        pri: "P2",
        resp: "支付/物流/仓储/检验/关务适配器的服务商配置与健康度。",
        owner: "Supply Chain",
        apis: [spec("scm", "GET", "/service-providers"), spec("scm", "POST", "/service-providers")],
        scope: "scm:order:read",
    },
    {
        id: "scm.analytics",
        path: "/analytics",
        zh: "数据驾驶舱",
        en: "Analytics",
        sys: "scm",
        pri: "P1",
        resp: "跨系统经营指标看板（订单、交付、质量、资金）。",
        owner: "Supply Chain（分析库）",
        apis: [spec("scm", "GET", "/analytics/dashboard")],
        scope: "scm:order:read",
    },
    {
        id: "scm.audit-logs",
        path: "/admin/audit-logs",
        zh: "审计日志",
        en: "Audit log",
        sys: "scm",
        pri: "P1",
        resp: "全平台写操作审计（audit_log），按租户隔离且不可篡改。",
        owner: "platform-core",
        apis: [spec("platform", "GET", "/audit-logs")],
        scope: "ops:read",
    },
];
/* ------------------------------------------------------------- manufacturing */
const MFG = [
    {
        id: "mfg.dashboard",
        path: "/factory",
        zh: "工厂 Dashboard",
        en: "Factory dashboard",
        sys: "mfg",
        pri: "P0",
        resp: "工厂侧总览：在制工单、产能占用、待报价 RFQ 与待结算金额。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/factories"), live("mfg", "GET", "/work-orders"), live("mfg", "GET", "/supplier-rfqs")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.onboarding",
        path: "/factory/onboarding",
        zh: "入驻申请",
        en: "Onboarding",
        sys: "mfg",
        pri: "P0",
        resp: "工厂入驻建档与资质提交，进入平台审核。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/factories"), live("mfg", "POST", "/factories/:factoryId/verification")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.profile",
        path: "/factory/profile",
        zh: "企业档案",
        en: "Factory profile",
        sys: "mfg",
        pri: "P0",
        resp: "工厂法定信息、所属产业带与审核状态。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/factories/:factoryId")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.certifications",
        path: "/factory/certifications",
        zh: "资质与认证",
        en: "Certifications",
        sys: "mfg",
        pri: "P1",
        resp: "ISO/环保/行业认证的有效性与到期提醒。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/factories/:factoryId/verification"), live("mfg", "GET", "/factories/:factoryId")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.capabilities",
        path: "/factory/capabilities",
        zh: "制造能力",
        en: "Capabilities",
        sys: "mfg",
        pri: "P0",
        resp: "工艺能力矩阵（3DP/CNC/注塑/PCB…），是工厂匹配的输入。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/factories/:factoryId/capabilities"), live("mfg", "PUT", "/factories/:factoryId/capabilities")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.equipment",
        path: "/factory/equipment",
        zh: "设备管理",
        en: "Equipment",
        sys: "mfg",
        pri: "P1",
        resp: "关键设备清单与可用状态，影响实际产能。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/factories/:factoryId/equipment")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.capacity",
        path: "/factory/capacity",
        zh: "产能日历",
        en: "Capacity",
        sys: "mfg",
        pri: "P1",
        resp: "按周期的可用产能与已占用产能，供排产与承诺交期。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/factories/:factoryId/capacity"), live("mfg", "PUT", "/factories/:factoryId/capacity")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.products",
        path: "/factory/products",
        zh: "商品列表",
        en: "Factory products",
        sys: "mfg",
        pri: "P0",
        resp: "工厂可供商品/工艺能力商品，向 Commerce 提供可售供给。",
        owner: "Manufacturing → Commerce",
        apis: [live("mfg", "GET", "/factories/:factoryId/products"), live("mfg", "POST", "/factories/:factoryId/products")],
        scope: "mfg:product:read",
    },
    {
        id: "mfg.product-edit",
        path: "/factory/products/:productId",
        zh: "商品创建 / 编辑",
        en: "Factory product editor",
        sys: "mfg",
        pri: "P0",
        resp: "工厂侧商品信息与价格/交期维护。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/factories/:factoryId/products"), live("commerce", "GET", "/products/:productId")],
        scope: "mfg:product:read",
    },
    {
        id: "mfg.skus",
        path: "/factory/skus",
        zh: "SKU 管理",
        en: "SKUs",
        sys: "mfg",
        pri: "P1",
        resp: "规格/SKU 级的价格、MOQ 与交期。",
        owner: "Manufacturing / Commerce",
        apis: [live("commerce", "GET", "/skus/:skuId"), live("commerce", "GET", "/products/:productId")],
        scope: "mfg:product:read",
    },
    {
        id: "mfg.rfqs",
        path: "/factory/rfqs",
        zh: "RFQ 工作台",
        en: "RFQ inbox",
        sys: "mfg",
        pri: "P0",
        resp: "工厂收到的询价单（来自平台派发）与响应状态。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/supplier-rfqs"), live("mfg", "POST", "/supplier-rfqs")],
        scope: "mfg:rfq:read",
    },
    {
        id: "mfg.rfq-detail",
        path: "/factory/rfqs/:rfqId",
        zh: "RFQ 详情",
        en: "Supplier RFQ",
        sys: "mfg",
        pri: "P0",
        resp: "询价明细与工厂报价录入。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/supplier-rfqs"), live("mfg", "POST", "/supplier-rfqs/:rfqId/quotes")],
        scope: "mfg:rfq:read",
    },
    {
        id: "mfg.quotes",
        path: "/factory/quotes",
        zh: "报价管理",
        en: "Supplier quotes",
        sys: "mfg",
        pri: "P0",
        resp: "工厂已提交报价的列表与状态。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/supplier-rfqs"), live("mfg", "POST", "/supplier-rfqs/:rfqId/quotes")],
        scope: "mfg:rfq:read",
    },
    {
        id: "mfg.quote-detail",
        path: "/factory/quotes/:rfqId",
        zh: "报价详情",
        en: "Supplier quote",
        sys: "mfg",
        pri: "P0",
        resp: "报价明细与商务条款，提交后进入平台比价。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/supplier-rfqs/:rfqId/quotes"), live("mfg", "GET", "/supplier-rfqs")],
        scope: "mfg:rfq:read",
    },
    {
        id: "mfg.purchase-orders",
        path: "/factory/purchase-orders",
        zh: "采购订单",
        en: "Purchase orders",
        sys: "mfg",
        pri: "P0",
        resp: "平台下发给工厂的 PO，需要确认接受（acknowledgement）。",
        owner: "Supply Chain（工厂视图）",
        apis: [live("scm", "GET", "/supplier-pos"), live("mfg", "POST", "/supplier-pos/:poId/acknowledgement")],
        scope: "mfg:po:read",
    },
    {
        id: "mfg.purchase-order-detail",
        path: "/factory/purchase-orders/:poId",
        zh: "PO 详情",
        en: "PO detail",
        sys: "mfg",
        pri: "P0",
        resp: "PO 明细、交期与确认状态；确认后进入生产。",
        owner: "Supply Chain（工厂视图）",
        apis: [live("scm", "GET", "/supplier-pos"), live("mfg", "POST", "/supplier-pos/:poId/acknowledgement")],
        scope: "mfg:po:read",
    },
    {
        id: "mfg.work-orders",
        path: "/factory/work-orders",
        zh: "工单列表",
        en: "Work orders",
        sys: "mfg",
        pri: "P0",
        resp: "工单创建（必须绑定工程版本）与状态跟踪。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/work-orders"), live("mfg", "POST", "/work-orders")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.work-order-detail",
        path: "/factory/work-orders/:workOrderId",
        zh: "工单详情",
        en: "Work order",
        sys: "mfg",
        pri: "P0",
        resp: "工单执行明细：生产进度上报、质检记录、完工与出货。",
        owner: "Manufacturing",
        apis: [
            live("mfg", "GET", "/work-orders/:workOrderId"),
            live("mfg", "POST", "/work-orders/:workOrderId/production-updates"),
            live("mfg", "GET", "/work-orders/:workOrderId/quality-records"),
            live("mfg", "POST", "/work-orders/:workOrderId/quality-records"),
            live("mfg", "POST", "/work-orders/:workOrderId/complete"),
            live("mfg", "POST", "/work-orders/:workOrderId/dispatches"),
        ],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.routings",
        path: "/factory/routings",
        zh: "工艺路线",
        en: "Routings",
        sys: "mfg",
        pri: "P1",
        resp: "工序序列、工时与依赖，构成工单排产基础。",
        owner: "Manufacturing",
        apis: [spec("mfg", "GET", "/routings"), spec("mfg", "POST", "/routings")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.production",
        path: "/factory/production",
        zh: "生产进度",
        en: "Production progress",
        sys: "mfg",
        pri: "P0",
        resp: "在制工单的产出/不良累计与达成率。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/work-orders"), live("mfg", "POST", "/work-orders/:workOrderId/production-updates")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.exceptions",
        path: "/factory/exceptions",
        zh: "生产异常",
        en: "Production exceptions",
        sys: "mfg",
        pri: "P1",
        resp: "停工、缺料、质量异常的登记与处置。",
        owner: "Manufacturing",
        apis: [spec("mfg", "GET", "/production-exceptions"), live("mfg", "POST", "/work-orders/:workOrderId/production-updates")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.quality",
        path: "/factory/quality",
        zh: "质量管理",
        en: "Quality",
        sys: "mfg",
        pri: "P0",
        resp: "过程/终检记录与判定，是平台放行的依据。",
        owner: "Manufacturing",
        apis: [live("mfg", "GET", "/work-orders/:workOrderId/quality-records"), live("mfg", "POST", "/work-orders/:workOrderId/quality-records")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.ncr",
        path: "/factory/ncr",
        zh: "不合格品",
        en: "Nonconforming product",
        sys: "mfg",
        pri: "P1",
        resp: "不合格批次隔离与处置建议。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/work-orders/:workOrderId/quality-records"), spec("mfg", "GET", "/ncr")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.dispatch",
        path: "/factory/dispatch",
        zh: "包装与出库",
        en: "Packing & dispatch",
        sys: "mfg",
        pri: "P0",
        resp: "完工批次的包装信息与出货登记，触发 SCM 货件衔接。",
        owner: "Manufacturing",
        apis: [live("mfg", "POST", "/work-orders/:workOrderId/dispatches"), live("mfg", "GET", "/work-orders/:workOrderId")],
        scope: "mfg:wo:read",
    },
    {
        id: "mfg.settlements",
        path: "/factory/settlements",
        zh: "对账与结算",
        en: "Settlements",
        sys: "mfg",
        pri: "P1",
        resp: "工厂结算单的创建与查询，与 SCM 账本对账。",
        owner: "Manufacturing / Supply Chain",
        apis: [live("mfg", "GET", "/factories/:factoryId/settlements"), live("mfg", "POST", "/factories/:factoryId/settlements")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.ai-assistant",
        path: "/factory/ai-assistant",
        zh: "AI 制造助手",
        en: "AI manufacturing assistant",
        sys: "mfg",
        pri: "P1",
        resp: "面向工厂的工艺问答与报价辅助（复用 R&D Agent 运行时）。",
        owner: "AI Product R&D",
        apis: [spec("rnd", "POST", "/agent-runs"), live("rnd", "GET", "/agent-runs")],
        scope: "mfg:factory:read",
    },
    {
        id: "mfg.members",
        path: "/factory/settings/members",
        zh: "成员与权限",
        en: "Factory members",
        sys: "mfg",
        pri: "P1",
        resp: "工厂账号与角色（生产/质量/商务）权限分配。",
        owner: "Manufacturing",
        apis: [spec("mfg", "GET", "/factories/:factoryId/members"), spec("mfg", "POST", "/factories/:factoryId/members")],
        scope: "mfg:factory:read",
    },
];
/* --------------------------------------------------------------------- admin */
const ADMIN = [
    {
        id: "admin.users",
        path: "/admin/users",
        zh: "用户管理",
        en: "Users",
        sys: "admin",
        pri: "P1",
        resp: "用户与 Logto 身份的映射、状态与所属组织。",
        owner: "platform-core + Logto",
        apis: [spec("platform", "GET", "/admin/users")],
        scope: "ops:read",
    },
    {
        id: "admin.organizations",
        path: "/admin/organizations",
        zh: "组织管理",
        en: "Organizations",
        sys: "admin",
        pri: "P1",
        resp: "租户/组织档案与 Logto organization 映射，是租户隔离的根。",
        owner: "platform-core + Logto",
        apis: [spec("platform", "GET", "/admin/organizations")],
        scope: "ops:read",
    },
    {
        id: "admin.categories",
        path: "/admin/categories",
        zh: "类目管理",
        en: "Categories",
        sys: "admin",
        pri: "P1",
        resp: "类目树与行业属性模板的维护。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/products", "按 category_id 过滤校验")],
        scope: "commerce:catalog:read",
    },
    {
        id: "admin.attributes",
        path: "/admin/attributes",
        zh: "行业属性模板",
        en: "Attribute templates",
        sys: "admin",
        pri: "P1",
        resp: "按类目定义强制/可选属性，保证供给数据结构一致。",
        owner: "Commerce",
        apis: [live("commerce", "GET", "/products/:productId", "SKU attributes 结构")],
        scope: "commerce:catalog:read",
    },
    {
        id: "admin.marketplaces",
        path: "/admin/marketplaces",
        zh: "国家 / 市场配置",
        en: "Markets",
        sys: "admin",
        pri: "P1",
        resp: "目的国市场配置：币种、税率、准入与物流选项。",
        owner: "SCM",
        apis: [spec("scm", "GET", "/admin/marketplaces"), live("platform", "GET", "/i18n/rates")],
        scope: "ops:read",
    },
    {
        id: "admin.fees",
        path: "/admin/fees",
        zh: "平台费用规则",
        en: "Fee rules",
        sys: "admin",
        pri: "P1",
        resp: "平台佣金/服务费/支付通道费的规则与生效版本。",
        owner: "SCM",
        apis: [spec("scm", "GET", "/admin/fees")],
        scope: "scm:payment:read",
    },
    {
        id: "admin.workflows",
        path: "/admin/workflows",
        zh: "审批与工作流",
        en: "Workflows",
        sys: "admin",
        pri: "P1",
        resp: "工作流定义、实例与待办任务的统一运维。",
        owner: "platform-core",
        apis: [
            live("platform", "GET", "/workflow-tasks"),
            live("platform", "POST", "/workflow-definitions"),
            live("platform", "POST", "/workflow-instances"),
            live("platform", "GET", "/workflow-instances/:instanceId"),
            live("platform", "POST", "/workflow-tasks/:taskId/decision"),
        ],
        scope: "platform:workflow:read",
    },
    {
        id: "admin.integrations",
        path: "/admin/integrations",
        zh: "第三方集成",
        en: "Integrations",
        sys: "admin",
        pri: "P1",
        resp: "支付/物流/仓储/检验/关务适配器的接入配置与回调端点。",
        owner: "SCM",
        apis: [live("scm", "POST", "/webhooks/payment-providers/:provider"), spec("scm", "GET", "/service-providers")],
        scope: "ops:read",
    },
    {
        id: "admin.events",
        path: "/admin/events",
        zh: "事件监控和死信",
        en: "Event runtime",
        sys: "admin",
        pri: "P1",
        resp: "五库 Outbox/Inbox 健康、死信列表与人工重放，是分布一致性的运维面。",
        owner: "platform-core（事件运行时）",
        apis: [
            live("commerce", "GET", "/ops/outbox"),
            live("commerce", "GET", "/ops/dead-letters"),
            live("commerce", "GET", "/ops/inbox-failures"),
            live("commerce", "POST", "/ops/dead-letters/:eventId/replay"),
        ],
        scope: "ops:read",
    },
    {
        id: "admin.feature-flags",
        path: "/admin/feature-flags",
        zh: "功能开关",
        en: "Feature flags",
        sys: "admin",
        pri: "P2",
        resp: "按租户/环境的功能灰度开关。",
        owner: "platform-core",
        apis: [spec("platform", "GET", "/admin/feature-flags")],
        scope: "ops:read",
    },
    {
        id: "admin.policies",
        path: "/admin/policies",
        zh: "访问、风控和业务策略",
        en: "Policies",
        sys: "admin",
        pri: "P2",
        resp: "访问控制、风控与业务策略（限额/黑名单/审批阈值）。",
        owner: "platform-core",
        apis: [spec("platform", "GET", "/admin/policies")],
        scope: "ops:read",
    },
];
export const ROUTES = [...COMMERCE, ...RND, ...SCM, ...MFG, ...ADMIN];
/** 33 + 21 + 29 + 27 + 11 = 121 — PRD 附录 A. */
export const ROUTE_COUNTS = {
    commerce: COMMERCE.length,
    rnd: RND.length,
    scm: SCM.length,
    mfg: MFG.length,
    admin: ADMIN.length,
};
export const routeCount = () => ROUTES.length;
export const SYSTEM_META = {
    commerce: { zh: "商业系统 · 买家端", en: "Commerce · Buyer", navKey: "nav.commerce" },
    rnd: { zh: "AI 产品研发", en: "AI Product R&D", navKey: "nav.rnd" },
    scm: { zh: "供应链控制塔", en: "Supply Chain Control Tower", navKey: "nav.scm" },
    mfg: { zh: "制造网络 · 工厂端", en: "Manufacturing Network · Factory", navKey: "nav.mfg" },
    admin: { zh: "平台管理", en: "Platform Admin", navKey: "nav.admin" },
};
export const byId = (id) => ROUTES.find((r) => r.id === id);
/** A page is "wired" when at least one of its operations is live. */
export const isWired = (r) => r.apis.some((a) => a.state === "live");
export const coverage = () => {
    const total = ROUTES.length;
    const wired = ROUTES.filter(isWired).length;
    const liveApis = ROUTES.reduce((n, r) => n + r.apis.filter((a) => a.state === "live").length, 0);
    const contractApis = ROUTES.reduce((n, r) => n + r.apis.filter((a) => a.state === "contract").length, 0);
    const uniqueLive = new Set(ROUTES.flatMap((r) => r.apis.filter((a) => a.state === "live").map((a) => `${a.member}:${a.method} ${a.path}`))).size;
    return { total, wired, specOnly: total - wired, liveApis, contractApis, uniqueLive };
};
/** Nav groups: only routes whose scope the session holds. */
export function navFor(scopes) {
    const allow = (r) => !r.scope ||
        scopes.some((s) => {
            if (s === "*")
                return true;
            if (s === r.scope)
                return true;
            if (s.endsWith(":*"))
                return r.scope.startsWith(s.slice(0, -1));
            if (s.endsWith("*"))
                return r.scope.startsWith(s.slice(0, -1));
            return false;
        });
    return ["commerce", "rnd", "scm", "mfg", "admin"]
        .map((sys) => ({ sys, items: ROUTES.filter((r) => r.sys === sys && allow(r)) }))
        .filter((g) => g.items.length > 0);
}
